import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "app/views/chart/chart.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {DomainZonesDetailsComponent} from "./details/domain_zones_details.component";
import { DomainsService } from "../domains.service";
import { FilterParams } from "../../models/filter_form.model";

@Component({
	selector: 'domain-zones',
	templateUrl: './domain_zones.component.html'
})
export class DomainZonesComponent extends BaseComponent {
	loader: boolean = false;
	
	chart = new ChartParams({
		type : 'pie'
	});
	
	stats = [];
	
	addFilterParams = {
		userType: 'user',
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
	};
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		private http: HttpClient,
		private helper: HelperService,
		private modalService: ModalService,
		public domainsService: DomainsService,
	) {
		super(eventsService, domainsService, activatedRoute, filter, translate);
	}
	
	async getData() {
		await this.getStats();
	}
	
	
	async getStats() {
		this.loader = true;
		
		const { stats } = await this.domainsService.zones.stats(
			this.filter.filterParams
		).toPromise();
		this.stats = stats;
		
		let chartData = [];
		
		this.stats.forEach(function(stat) {
			chartData.push([stat.zone, stat.total]);
		});

		this.chart.data = chartData;

		this.loader = false;
	}
	
	
	async showDetails(zone: string, type: string) {
		const modalRef = this.modalService.open(DomainZonesDetailsComponent, {
			title: `${zone} - ${this.translate.__A('billing.domain_zones.' + type)}`
		}, {size: 'hg'});

		const { stats } = await this.domainsService.zones.detail(
			this.filter.getCopyFilterParams(<FilterParams>{ zone, type })
		).toPromise();
		modalRef.componentInstance.details = stats;
	}
}
